import {keyframes} from "styled-components";
import {generateRandomNumber} from "../../../../../common/utils/math-util";
import {generateArray} from "../../../../../utils/array-helper";

// This part is out of the component because I don't want to recompute each render. Once at the loading of the JS is enough.
export const MAX_CONFETTI_PIECES = 60;
const CONFETTI_SHAPE_SIZE_MIN = 9;
const CONFETTI_SHAPE_SIZE_MAX = 18;
export const enum CONFETTI_SHAPE {
    Rectangle = 0,
    Triangle,
    Circle
}

const confettiColors = [
    "#ffffff", // white
    "#c49752", // yellow-ish brown (more brown less yellow)
    "#e5d194", // brown-ish yellow (more yellow less brown)
    "#7ff800" // brand primary green // "#f935a9" // pink
];
const confettiRotateDegree = 1080;

export const confettiCharacteristics = generateArray(MAX_CONFETTI_PIECES, (i) => {
    return {
        animationDuration: generateRandomNumber(1, 2), // generates 1 or 2
        size: generateRandomNumber(CONFETTI_SHAPE_SIZE_MIN, CONFETTI_SHAPE_SIZE_MAX),
        shape: generateRandomNumber(2) as CONFETTI_SHAPE, // generates 0, 1 or 2
        shapeDeformFactor: (() => {
            // I would use the same size generated before but in sass borrowed from WH the size is recomputed. Don't know why, I will experiment
            const size = generateRandomNumber(CONFETTI_SHAPE_SIZE_MIN, CONFETTI_SHAPE_SIZE_MAX);
            const factor = generateRandomNumber(1); // generates 0 or 1
            if (factor) {
                return {height: size + 10, width: size - 5};
            } else {
                return {height: size - 5, width: size + 10};
            }
        })(), // ATTENTION auto called function. DO NOT REMOVE THE END PARANTHESIS.
        shapeTriangleProps: {
            borderLeft: generateRandomNumber(CONFETTI_SHAPE_SIZE_MAX) + CONFETTI_SHAPE_SIZE_MIN,
            borderRight: generateRandomNumber(CONFETTI_SHAPE_SIZE_MAX) + CONFETTI_SHAPE_SIZE_MIN,
            borderBottom: generateRandomNumber(CONFETTI_SHAPE_SIZE_MAX) + CONFETTI_SHAPE_SIZE_MIN,
        },
        color: confettiColors[ generateRandomNumber( confettiColors.length ) ],
        directionOfTravel: {x: generateRandomNumber(-50, 50), y: generateRandomNumber(-50, 50)}
    }
});

export const confettiKeyframesList = confettiCharacteristics.map(props => {
    return {
        spreadAndFall: keyframes`
            0% {
                transform: translate(-50%, -50%) translate(0, 0) rotate(0deg);
                opacity: 1;
            }
            70% {
                opacity: 1;
            }
            100% {
                transform: translate(-50%, -50%)
                    translate(${props.directionOfTravel.x}vw, ${props.directionOfTravel.y}vh)
                    rotate(${confettiRotateDegree}deg);
                opacity: 0;
            }
        `,
        changeShape: keyframes`
            50% {
                height: calc(${props.shapeDeformFactor.height}px);
                width: calc(${props.shapeDeformFactor.width}px);
            }
        `
    }
});


export const confettiStripsCharacteristics = generateArray(3, (i) => {
    return {
        size: generateRandomNumber(2, CONFETTI_SHAPE_SIZE_MAX),
        color: confettiColors[ generateRandomNumber( confettiColors.length-1 ) ]
    }
});